
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("guhEN", function(module, exports) {
/* ViewPdfMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $glkQ6 = parcelRequire("glkQ6");


var $a86m3 = parcelRequire("a86m3");


var $eMuR8 = parcelRequire("eMuR8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $kCqKs = parcelRequire("kCqKs");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $jqlpB = parcelRequire("jqlpB");

/**
 * Zoom level logic for the ViewPDF macro.
 *
 * Adapted from @atlaskit/media-viewer/src/domain/zoomLevel.ts
 * Copied here to avoid a dependency on the internal non-exported module.
 */ const $fbf92b5a2fc7bd1d$var$BASE_ZOOM_LEVELS = [
    0.06,
    0.12,
    0.24,
    0.48,
    1,
    1.5,
    2,
    4,
    6,
    8
];
const $fbf92b5a2fc7bd1d$var$sortNumbers = (nums)=>{
    return nums.sort((a, b)=>a - b);
};
const $fbf92b5a2fc7bd1d$var$deduplicated = (nums)=>{
    return $fbf92b5a2fc7bd1d$var$sortNumbers(nums).filter((num, pos)=>pos === 0 || num !== nums[pos - 1]);
};
class $fbf92b5a2fc7bd1d$export$a5b687709003be23 {
    get zoomLevels() {
        return $fbf92b5a2fc7bd1d$var$deduplicated($fbf92b5a2fc7bd1d$var$sortNumbers($fbf92b5a2fc7bd1d$var$BASE_ZOOM_LEVELS.map((zoomLevel)=>zoomLevel * this.initialValue).concat(1)));
    }
    get min() {
        return this.zoomLevels[0];
    }
    get max() {
        return this.zoomLevels.slice(-1)[0];
    }
    get asPercentage() {
        return `${Math.round(this.value / this.initialValue * 100)} %`;
    }
    zoomIn() {
        const index = this.zoomLevels.indexOf(this.value);
        const nextValue = this.zoomLevels[index + 1];
        return nextValue ? new $fbf92b5a2fc7bd1d$export$a5b687709003be23(this.initialValue, nextValue) : this;
    }
    zoomOut() {
        const index = this.zoomLevels.indexOf(this.value);
        const nextValue = this.zoomLevels[index - 1];
        return nextValue ? new $fbf92b5a2fc7bd1d$export$a5b687709003be23(this.initialValue, nextValue) : this;
    }
    fullyZoomIn() {
        return new $fbf92b5a2fc7bd1d$export$a5b687709003be23(this.initialValue, this.max);
    }
    fullyZoomOut() {
        return new $fbf92b5a2fc7bd1d$export$a5b687709003be23(this.initialValue, this.min);
    }
    get canZoomIn() {
        return this.value < this.max;
    }
    get canZoomOut() {
        return this.value > this.min;
    }
    constructor(initialValue, selectedValue){
        this.initialValue = initialValue;
        this.value = void 0;
        if (selectedValue === undefined) selectedValue = initialValue;
        if (selectedValue < this.min) this.value = this.min;
        else if (selectedValue > this.max) this.value = this.max;
        else this.value = selectedValue;
    }
}





const $b7e527c236b05a58$export$f9daf4f55ac2bb4b = ({ isDisplayMode: isDisplayMode, mediaClient: mediaClient, mediaFileId: mediaFileId, collectionName: collectionName })=>{
    const [thumbnailObjectUrl, setThumbnailObjectUrl] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (isDisplayMode || !mediaClient || !mediaFileId) return;
        let objectUrl = null;
        let cancelled = false;
        mediaClient.mediaStore.getImage(mediaFileId, {
            collection: collectionName ?? undefined,
            width: 800,
            height: 600,
            mode: 'fit'
        }).then((blob)=>{
            // If the component unmounted, revoke the blob immediately instead of setting state.
            if (cancelled) {
                objectUrl = URL.createObjectURL(blob);
                URL.revokeObjectURL(objectUrl);
                return;
            }
            objectUrl = URL.createObjectURL(blob);
            setThumbnailObjectUrl(objectUrl);
        }).catch(()=>{
        // Silently fail; caller can fall through to DocumentViewer.
        });
        return ()=>{
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
            // Reset state to null to prevent rendering a revoked blob URL
            // when isDisplayMode transitions to true or other dependencies change.
            setThumbnailObjectUrl(null);
        };
    }, [
        isDisplayMode,
        mediaClient,
        mediaFileId,
        collectionName
    ]);
    return thumbnailObjectUrl;
};



var $15svH = parcelRequire("15svH");


var $jMyy4 = parcelRequire("jMyy4");




const $90a0f9ff272ad52e$export$41d6e2baedc5a142 = ({ contentId: contentId, attachmentName: attachmentName, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    // Cross-page mode: look up by title (+ optionally spaceKey and postingDay for blogs).
    // Same-page mode: look up by contentId.
    const isCrossPage = Boolean(normalizedPageName);
    // Skip only when core required params are missing.
    // We intentionally allow cross-page lookups without spaceKey to preserve legacy behavior.
    const skip = !contentId || !attachmentName;
    const variables = (0, $jqlpB.buildViewPdfQueryVariables)({
        contentId: contentId,
        pageName: normalizedPageName,
        spaceKey: spaceKey,
        date: date
    });
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $15svH.default), {
        variables: variables,
        skip: skip,
        fetchPolicy: 'cache-first',
        __callerPackage__: "viewpdf-macro"
    });
    // When required params are missing, return empty result (no error).
    if (skip) return {
        mediaFileId: null,
        collectionName: null,
        sourceContentId: null,
        isLoading: false,
        error: null
    };
    if (error) return {
        mediaFileId: null,
        collectionName: null,
        sourceContentId: null,
        isLoading: false,
        error: error
    };
    // Find the attachment whose title matches the requested attachment name.
    // Use case-insensitive matching to preserve legacy backend parity:
    // AttachmentManager.getAttachment() performs case-insensitive lookup.
    const contentNode = data?.content?.edges?.[0]?.node;
    const attachmentNodes = contentNode?.attachments?.nodes ?? [];
    const matchingAttachment = attachmentNodes.find((node)=>node?.title?.toLowerCase() === attachmentName?.toLowerCase());
    // Extract the media fileId from the attachment's extensions array.
    // The 'fileId' extension key is the Media API file ID (same as fileStoreId).
    const mediaFileId = matchingAttachment?.extensions?.find((ext)=>ext?.key === 'fileId')?.value ?? null;
    // collectionName is "contentId-{pageId}".
    // For cross-page, use the resolved page's id from the query response.
    // For same-page, use the current contentId.
    const resolvedContentId = isCrossPage ? contentNode?.id ?? null : contentId;
    const collectionName = resolvedContentId ? `contentId-${resolvedContentId}` : null;
    return {
        mediaFileId: mediaFileId,
        collectionName: collectionName,
        sourceContentId: resolvedContentId,
        isLoading: loading && !data,
        error: null
    };
};





const $431d7decc4868bd6$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    macroLabel: {
        id: "viewpdf-macro.label",
        defaultMessage: "View PDF"
    },
    loading: {
        id: "viewpdf-macro.loading",
        defaultMessage: "Loading PDF\u2026"
    },
    errorAttachmentNotFound: {
        id: "viewpdf-macro.error-attachment-not-found",
        defaultMessage: "PDF attachment not found. Please check the file name and page parameters."
    },
    error: {
        id: "viewpdf-macro.error",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We're unable to display the PDF. Refresh to try again."
    },
    zoomIn: {
        id: "viewpdf-macro.zoom-in",
        defaultMessage: "Zoom in"
    },
    zoomOut: {
        id: "viewpdf-macro.zoom-out",
        defaultMessage: "Zoom out"
    },
    fitToPage: {
        id: "viewpdf-macro.fit-to-page",
        defaultMessage: "Fit to page"
    },
    expandFullscreen: {
        id: "viewpdf-macro.expand-fullscreen",
        defaultMessage: "View fullscreen"
    },
    exitFullscreen: {
        id: "viewpdf-macro.exit-fullscreen",
        defaultMessage: "Exit fullscreen"
    },
    closeFullscreen: {
        id: "viewpdf-macro.close-fullscreen",
        defaultMessage: "Close"
    },
    presentationMode: {
        id: "viewpdf-macro.presentation-mode",
        defaultMessage: "Presentation mode"
    },
    exitPresentationMode: {
        id: "viewpdf-macro.exit-presentation-mode",
        defaultMessage: "Exit presentation mode"
    },
    previousPage: {
        id: "viewpdf-macro.previous-page",
        defaultMessage: "Previous page"
    },
    nextPage: {
        id: "viewpdf-macro.next-page",
        defaultMessage: "Next page"
    },
    pageCounter: {
        id: "viewpdf-macro.page-counter",
        defaultMessage: "{currentPage} / {totalPages}"
    }
});


/* ZoomToolbar.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $hBYtq = parcelRequire("hBYtq");


var $1sCHt = parcelRequire("1sCHt");


var $gucjn = parcelRequire("gucjn");


var $1UKaF = parcelRequire("1UKaF");


var $2x0Nk = parcelRequire("2x0Nk");


var $aDOBB = parcelRequire("aDOBB");


const $4d49be29f48cd363$var$styles = {
    container: "_2mHwu81Y8M _0bjKvD8fU6 _23rrnH0bPn _4c065U1Y8M _2Y7lL42ADO _1mT5xdWVPG _0Bm75G8HPE _3OE6xY715P _1VJPcajssS _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0KLXruoI2d _2OUyjtGk8v _42Yu6B7dHp",
    containerVisible: "_1YKVNs7dHp _1pp6NdIZbP",
    containerHidden: "_1YKVNsdnbC _1pp6NdYbGa",
    zoomLabel: "_0bjKvDKxmn _2Y7lL41Y8M _1kk5Tkf7mX _1UtDYzy7kJ _0wOv4Q7zJH _1ANEUSLRg7 _20VacPYbGa"
};
const $4d49be29f48cd363$export$68ee6013b715cf38 = ({ zoomLevel: zoomLevel, onChange: onChange, onFitToPage: onFitToPage, onExpandToggle: onExpandToggle, isFullscreen: isFullscreen, isVisible: isVisibleProp })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isVisibleInternal, setIsVisibleInternal] = (0, $cozmU.useState)(false);
    const hideTimerRef = (0, $cozmU.useRef)(null);
    const showToolbar = (0, $cozmU.useCallback)(()=>{
        if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
        setIsVisibleInternal(true);
    }, []);
    const scheduleHide = (0, $cozmU.useCallback)(()=>{
        if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
        hideTimerRef.current = setTimeout(()=>{
            setIsVisibleInternal(false);
        }, 2000);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
        };
    }, []); // In fullscreen/presentation mode, always show the toolbar.
    // If isVisibleProp is provided by a parent, use that; otherwise use internal hover state.
    const isVisible = isVisibleProp !== undefined ? isVisibleProp : isVisibleInternal;
    const toolbarVisible = isFullscreen || isVisible;
    const handleZoomOut = (0, $cozmU.useCallback)(()=>onChange(zoomLevel.zoomOut()), [
        onChange,
        zoomLevel
    ]);
    const handleZoomIn = (0, $cozmU.useCallback)(()=>onChange(zoomLevel.zoomIn()), [
        onChange,
        zoomLevel
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "viewpdf-zoom-toolbar",
        onMouseEnter: showToolbar,
        onMouseLeave: scheduleHide,
        onFocus: showToolbar,
        onBlur: scheduleHide,
        className: (0, $hekY6.default)([
            $4d49be29f48cd363$var$styles.container,
            toolbarVisible ? $4d49be29f48cd363$var$styles.containerVisible : $4d49be29f48cd363$var$styles.containerHidden
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gucjn))),
        label: formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).zoomOut),
        isDisabled: !zoomLevel.canZoomOut,
        onClick: handleZoomOut,
        appearance: "subtle",
        spacing: "compact",
        testId: "viewpdf-zoom-out"
    }), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $4d49be29f48cd363$var$styles.zoomLabel,
        "aria-label": formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).fitToPage),
        onClick: onFitToPage,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') onFitToPage();
        },
        testId: "viewpdf-zoom-level"
    }, zoomLevel.asPercentage), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1UKaF))),
        label: formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).zoomIn),
        isDisabled: !zoomLevel.canZoomIn,
        onClick: handleZoomIn,
        appearance: "subtle",
        spacing: "compact",
        testId: "viewpdf-zoom-in"
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($aDOBB))) : (0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))),
        label: isFullscreen ? formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).exitPresentationMode) : formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).presentationMode),
        onClick: onExpandToggle,
        appearance: "subtle",
        spacing: "compact",
        testId: "viewpdf-fullscreen-toggle"
    }));
};
const $4d49be29f48cd363$export$51704b9b1cb72781 = ()=>{
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const hideTimerRef = (0, $cozmU.useRef)(null);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
        setIsVisible(true);
    }, []);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
        hideTimerRef.current = setTimeout(()=>{
            setIsVisible(false);
        }, 2000);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
        };
    }, []);
    return {
        isVisible: isVisible,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
};


/* FullscreenViewer.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $9kbTQ = parcelRequire("9kbTQ");








var $l3wuH = parcelRequire("l3wuH");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");





var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");



const $5a2570a3478a7d8f$var$presentationInitialState = {
    zoomLevel: new (0, $fbf92b5a2fc7bd1d$export$a5b687709003be23)(1),
    currentPage: 1,
    totalPages: 0
};
const $5a2570a3478a7d8f$export$4fc19f314172d33f = (state, action)=>{
    switch(action.type){
        case 'set_zoom_level':
            return {
                ...state,
                zoomLevel: action.zoomLevel
            };
        case 'set_total_pages':
            return {
                ...state,
                totalPages: action.totalPages
            };
        case 'go_to_page':
            {
                const page = Math.max(1, Math.min(action.page, state.totalPages || 1));
                return {
                    ...state,
                    currentPage: page
                };
            }
        default:
            return state;
    }
};
const $5a2570a3478a7d8f$export$eb7793b08d52e678 = (container, currentPage)=>{
    if (!container) return;
    const pageEl = container.querySelector(`#page-${currentPage}`);
    if (pageEl && typeof pageEl.scrollIntoView === 'function') pageEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
};
// ── Styles ───────────────────────────────────────────────────────────────────
const $5a2570a3478a7d8f$var$styles = {
    backdrop: "_49OCfRdnbC _1mT5xdy1CL _42Yu6BFIQA _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrugozt",
    overlay: "_1mT5xdRAKS _39xV02jeu6 _0jFU0VN9sL _3iDTPbQ4SZ _0aFT5vbt8w",
    viewerContainer: "_4bt5LAIZbP _2WAcuGIZbP _1mT5xdRAKS _39xV02N91d _0jFU0VN91d",
    closeButton: "_1mT5xdWVPG _2IhTondnbC _1VJPcaUXNQ _1OKFqYdnbC",
    toolbar: "_2mHwu81Y8M _0bjKvD8fU6 _4c065U1Y8M _2Y7lL42ADO _3iDTPbccYA _0hPCNLDIqT _0KLXruoI2d _2OUyjtGk8v",
    pageCounter: "_4ouGXI9LX5 _2fwxA5DIqT",
    separator: "_2YLqiK1Y8M _39xV02HZdu _0jFU0VSPN1 _3YEZNOdnbC _0KLXruDMqu",
    toolbarContainer: "_4c065U8HPE _3iDTPbQ4SZ _37wbyuDIqT"
};
const $5a2570a3478a7d8f$var$PresentationToolbar = ({ currentPage: currentPage, totalPages: totalPages, onPrevPage: onPrevPage, onNextPage: onNextPage, onExit: onExit })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "viewpdf-presentation-toolbar",
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.toolbar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).previousPage),
        isDisabled: currentPage <= 1,
        onClick: onPrevPage,
        appearance: "subtle",
        spacing: "compact",
        testId: "viewpdf-prev-page"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "viewpdf-page-counter",
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.pageCounter
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        align: "center"
    }, totalPages > 0 ? formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).pageCounter, {
        currentPage: currentPage,
        totalPages: totalPages
    }) : String(currentPage))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        label: formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).nextPage),
        isDisabled: totalPages > 0 && currentPage >= totalPages,
        onClick: onNextPage,
        appearance: "subtle",
        spacing: "compact",
        testId: "viewpdf-next-page"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.separator
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).exitPresentationMode),
        onClick: onExit,
        appearance: "subtle",
        spacing: "compact",
        testId: "viewpdf-exit-presentation"
    })));
}; // ── FullscreenViewer ──────────────────────────────────────────────────────────
const $5a2570a3478a7d8f$export$521c68b92cc5942d = ({ getContent: getContent, getPageImageUrl: getPageImageUrl, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state, dispatch] = (0, $cozmU.useReducer)($5a2570a3478a7d8f$export$4fc19f314172d33f, $5a2570a3478a7d8f$var$presentationInitialState);
    const closeButtonRef = (0, $cozmU.useRef)(null);
    const viewerContainerRef = (0, $cozmU.useRef)(null);
    const openerElementRef = (0, $cozmU.useRef)(null); // Capture the triggering element before the viewer steals focus
    (0, $cozmU.useEffect)(()=>{
        openerElementRef.current = document.activeElement;
        return ()=>{
            const opener = openerElementRef.current;
            if (opener instanceof HTMLElement && opener.isConnected) opener.focus();
        };
    }, []); // Focus the close button on mount for accessibility
    (0, $cozmU.useEffect)(()=>{
        closeButtonRef.current?.focus();
    }, []); // Fetch total page count on mount
    (0, $cozmU.useEffect)(()=>{
        getContent(0, 1).then((result)=>{
            const total = result?.total_pages ?? 0;
            if (total > 0) dispatch({
                type: 'set_total_pages',
                totalPages: total
            });
        }).catch(()=>{});
    }, [
        getContent
    ]); // Scroll to the current page when it changes
    (0, $cozmU.useEffect)(()=>{
        $5a2570a3478a7d8f$export$eb7793b08d52e678(viewerContainerRef.current, state.currentPage);
    }, [
        state.currentPage
    ]); // Keyboard: Escape to close, Arrow/Page keys to navigate
    (0, $cozmU.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') onClose();
            else if (e.key === 'ArrowLeft' || e.key === 'PageUp') dispatch({
                type: 'go_to_page',
                page: state.currentPage - 1
            });
            else if (e.key === 'ArrowRight' || e.key === 'PageDown') dispatch({
                type: 'go_to_page',
                page: state.currentPage + 1
            });
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onClose,
        state.currentPage
    ]);
    const onPrevPage = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'go_to_page',
            page: state.currentPage - 1
        });
    }, [
        state.currentPage
    ]);
    const onNextPage = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'go_to_page',
            page: state.currentPage + 1
        });
    }, [
        state.currentPage
    ]);
    const handleBackdropClick = (0, $cozmU.useCallback)((e)=>{
        // Only close when clicking the backdrop itself, not the overlay content
        if (e.target === e.currentTarget) onClose();
    }, [
        onClose
    ]);
    const handleBackdropKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.target === e.currentTarget && (e.key === 'Escape' || e.key === 'Enter')) onClose();
    }, [
        onClose
    ]);
    const overlay = /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "viewpdf-fullscreen-backdrop",
        onClick: handleBackdropClick,
        onKeyDown: handleBackdropKeyDown,
        role: "presentation",
        tabIndex: -1,
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.backdrop
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "viewpdf-fullscreen-overlay",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).presentationMode),
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.overlay
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.closeButton
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        ref: closeButtonRef,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).closeFullscreen),
        onClick: onClose,
        appearance: "subtle",
        testId: "viewpdf-fullscreen-close"
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: viewerContainerRef,
        "data-testid": "viewpdf-fullscreen-viewer-container",
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.viewerContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $a86m3.DocumentViewer), {
        getContent: getContent,
        getPageImageUrl: getPageImageUrl,
        zoom: state.zoomLevel.value
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $5a2570a3478a7d8f$var$styles.toolbarContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignInline: "center",
        space: "space.0"
    }, /*#__PURE__*/ $cozmU.createElement($5a2570a3478a7d8f$var$PresentationToolbar, {
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        onPrevPage: onPrevPage,
        onNextPage: onNextPage,
        onExit: onClose
    }))))); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(overlay, document.body);
};


const $ab2d871b1e9a6c2b$export$ac4d1f313c318334 = '100%';
const $ab2d871b1e9a6c2b$export$7ce912260e18e60d = '650px';
const $ab2d871b1e9a6c2b$var$initialState = {
    zoomLevel: new (0, $fbf92b5a2fc7bd1d$export$a5b687709003be23)(1),
    isLoading: true,
    isFullscreen: false
};
const $ab2d871b1e9a6c2b$var$reducer = (state, action)=>{
    if (action.type === 'loading_completed') return {
        ...state,
        isLoading: false
    };
    if (action.type === 'set_zoom_level') return {
        ...state,
        zoomLevel: action.zoomLevel
    };
    if (action.type === 'toggle_fullscreen') return {
        ...state,
        isFullscreen: !state.isFullscreen
    };
    return state;
};
const $ab2d871b1e9a6c2b$var$styles = {
    thumbnailContainer: "_1mT5xdRAKS _3iDTPbvLZJ"
};
const $ab2d871b1e9a6c2b$var$documentScrollRootStyles = null;
const $ab2d871b1e9a6c2b$var$getFitToWidthZoomLevel = ({ containerWidth: containerWidth, pageWidth: pageWidth })=>{
    if (!Number.isFinite(containerWidth) || !Number.isFinite(pageWidth) || containerWidth <= 0 || pageWidth <= 0) return null;
    return new (0, $fbf92b5a2fc7bd1d$export$a5b687709003be23)(containerWidth / pageWidth);
};
const $ab2d871b1e9a6c2b$var$toError = (err)=>{
    if (err instanceof Error) return err;
    const message = typeof err === 'string' ? err : 'Unknown error';
    return new Error(message);
};
const $ab2d871b1e9a6c2b$var$ViewPdfMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state, dispatch] = (0, $cozmU.useReducer)($ab2d871b1e9a6c2b$var$reducer, $ab2d871b1e9a6c2b$var$initialState);
    const { extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const trackingAttributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { attachmentName: attachmentName, pageName: pageName, spaceKey: spaceKey, date: date, viewerWidth: viewerWidth, viewerHeight: viewerHeight } = (0, $jqlpB.parseViewPdfMacroParams)(macroParams);
    const contentId = macroDefaultProps?.contentId ?? null;
    const attributeMacroId = macroDefaultProps?.attributes?.macroId; // Generate a unique scroll root ID per macro instance by appending macroId.
    // This prevents DOM ID collisions when multiple viewpdf macros are rendered on the same page.
    const scrollRootId = attributeMacroId ? `${0, $glkQ6.DOCUMENT_SCROLL_ROOT_ID}-${attributeMacroId}` : (0, $glkQ6.DOCUMENT_SCROLL_ROOT_ID);
    const isDisplayMode = macroDefaultProps?.mode === 'renderer' || macroDefaultProps?.mode == null;
    const isEditorMode = mode === 'editor';
    const { mediaFileId: mediaFileId, collectionName: collectionName, sourceContentId: sourceContentId, isLoading: isLoading, error: error } = (0, $90a0f9ff272ad52e$export$41d6e2baedc5a142)({
        contentId: contentId,
        attachmentName: attachmentName,
        pageName: pageName,
        spaceKey: spaceKey,
        date: date
    });
    const mediaClient = (0, $kCqKs.useMediaClient)({
        contentId: sourceContentId ?? contentId ?? undefined,
        readOnly: true
    });
    const [viewerError, setViewerError] = (0, $cozmU.useState)(null);
    const blobUrlsRef = (0, $cozmU.useRef)(new Set());
    const hasTrackedSuccessRef = (0, $cozmU.useRef)(false);
    const scrollRootRef = (0, $cozmU.useRef)(null);
    const fitToWidthZoomLevelRef = (0, $cozmU.useRef)($ab2d871b1e9a6c2b$var$initialState.zoomLevel);
    const hasUserChangedZoomRef = (0, $cozmU.useRef)(false); // Cleanup: revoke all created blob URLs on unmount to prevent memory leaks.
    (0, $cozmU.useEffect)(()=>{
        const blobUrls = blobUrlsRef.current;
        return ()=>{
            blobUrls.forEach((blobUrl)=>{
                URL.revokeObjectURL(blobUrl);
            });
            blobUrls.clear();
        };
    }, []);
    const thumbnailObjectUrl = (0, $b7e527c236b05a58$export$f9daf4f55ac2bb4b)({
        isDisplayMode: isDisplayMode,
        mediaClient: mediaClient,
        mediaFileId: mediaFileId,
        collectionName: collectionName
    });
    const getContent = (0, $eMuR8.useStaticCallback)(async (pageStart, pageEnd)=>{
        if (!mediaClient || !mediaFileId) {
            const clientError = new Error('Media client or file ID not available');
            setViewerError(clientError);
            throw clientError;
        }
        try {
            const result = await mediaClient.mediaStore.getDocumentContent(mediaFileId, {
                pageStart: pageStart,
                pageEnd: pageEnd,
                collectionName: collectionName ?? undefined
            });
            const pageWidth = result.pages[0]?.width;
            const fitToWidthZoomLevel = $ab2d871b1e9a6c2b$var$getFitToWidthZoomLevel({
                containerWidth: scrollRootRef.current?.clientWidth ?? 0,
                pageWidth: pageWidth ?? 0
            });
            if (fitToWidthZoomLevel) {
                fitToWidthZoomLevelRef.current = fitToWidthZoomLevel;
                if (!hasUserChangedZoomRef.current) dispatch({
                    type: 'set_zoom_level',
                    zoomLevel: fitToWidthZoomLevel
                });
            }
            dispatch({
                type: 'loading_completed'
            });
            return result;
        } catch (fetchError) {
            const normalizedError = $ab2d871b1e9a6c2b$var$toError(fetchError);
            setViewerError(normalizedError);
            throw normalizedError;
        }
    });
    const getPageImageUrl = (0, $eMuR8.useStaticCallback)(async (pageNumber, zoom)=>{
        if (!mediaClient || !mediaFileId) {
            const clientError = new Error('Media client or file ID not available');
            setViewerError(clientError);
            throw clientError;
        }
        try {
            const blob = await mediaClient.mediaStore.getDocumentPageImage(mediaFileId, {
                page: pageNumber,
                zoom: zoom,
                collectionName: collectionName ?? undefined
            });
            const newUrl = URL.createObjectURL(blob);
            blobUrlsRef.current.add(newUrl);
            return newUrl;
        } catch (fetchError) {
            const normalizedError = $ab2d871b1e9a6c2b$var$toError(fetchError);
            setViewerError(normalizedError);
            throw normalizedError;
        }
    });
    const onSuccess = (0, $eMuR8.useStaticCallback)(()=>{
        if (!hasTrackedSuccessRef.current) {
            (0, $5kjCz.getMacroExperienceTracker)(mode, macroDefaultProps.contentId).succeed({
                name: experienceName,
                attributes: trackingAttributes
            });
            hasTrackedSuccessRef.current = true;
        }
        dispatch({
            type: 'loading_completed'
        });
    });
    const onZoomChange = (0, $cozmU.useCallback)((newZoomLevel)=>{
        hasUserChangedZoomRef.current = true;
        dispatch({
            type: 'set_zoom_level',
            zoomLevel: newZoomLevel
        });
    }, []);
    const onFitToPage = (0, $cozmU.useCallback)(()=>{
        hasUserChangedZoomRef.current = true;
        dispatch({
            type: 'set_zoom_level',
            zoomLevel: fitToWidthZoomLevelRef.current
        });
    }, []);
    const onExpandToggle = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'toggle_fullscreen'
        });
    }, []);
    const { isVisible: isVisible, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = (0, $4d49be29f48cd363$export$51704b9b1cb72781)();
    const displayError = error ?? viewerError;
    if (displayError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !hasTrackedSuccessRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: macroDefaultProps.contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: trackingAttributes,
        error: displayError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: displayError
    }));
    if (!contentId) {
        const missingContentIdError = new Error(formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).errorAttachmentNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: macroDefaultProps.contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes,
            error: missingContentIdError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: missingContentIdError
        }));
    } // Don't render a spinner here — it creates a UFO hold on VC90. Render null and let
    // DocumentViewer's overlay handle loading state. mediaClient must stay in the guard:
    // its absence causes getContent/getPageImageUrl to throw, triggering MacroExperienceFailure.
    if (isLoading || !mediaClient) return null;
    if (!mediaFileId) {
        const missingAttachmentError = new Error(formatMessage((0, $431d7decc4868bd6$export$a7357cdd1f0b0168).errorAttachmentNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: macroDefaultProps.contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes,
            error: missingAttachmentError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: missingAttachmentError
        }));
    } // In export/email mode, show a thumbnail image fallback if one was generated.
    if (!isDisplayMode && thumbnailObjectUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ab2d871b1e9a6c2b$var$styles.thumbnailContainer,
        testId: "viewpdf-macro-thumbnail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: thumbnailObjectUrl,
        alt: attachmentName ?? ''
    })));
     // Editor mode should not mount DocumentViewer; it is expensive and can hold VC90 open.
    if (isEditorMode) return null;
    if (isDisplayMode && !attributeMacroId) return null;
     // Display mode: render the Platform Media DocumentViewer.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic values from macro params cannot be expressed as static CSS
    , {
        style: {
            width: viewerWidth,
            height: viewerHeight,
            position: 'relative'
        },
        "data-testid": "viewpdf-macro-viewer",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onMouseEnter,
        onBlur: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: scrollRootRef,
        id: scrollRootId,
        "data-testid": "viewpdf-macro-scroll-root",
        style: {
            opacity: state.isLoading ? 0 : 1
        },
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a86m3.DocumentViewer), {
        getContent: getContent,
        getPageImageUrl: getPageImageUrl,
        zoom: state.zoomLevel.value,
        onSuccess: onSuccess
    })), !state.isLoading && isDisplayMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d49be29f48cd363$export$68ee6013b715cf38), {
        zoomLevel: state.zoomLevel,
        onChange: onZoomChange,
        onFitToPage: onFitToPage,
        onExpandToggle: onExpandToggle,
        isFullscreen: state.isFullscreen,
        isVisible: isVisible
    }), state.isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a2570a3478a7d8f$export$521c68b92cc5942d), {
        getContent: getContent,
        getPageImageUrl: getPageImageUrl,
        onClose: onExpandToggle
    }));
};
const $ab2d871b1e9a6c2b$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $431d7decc4868bd6$export$a7357cdd1f0b0168).error);
const $ab2d871b1e9a6c2b$export$ed196922a2e8619 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $ab2d871b1e9a6c2b$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab2d871b1e9a6c2b$var$ViewPdfMacroRendererComponent, props));
};
module.exports["DEFAULT_VIEWER_WIDTH"] = $ab2d871b1e9a6c2b$export$ac4d1f313c318334;
module.exports["DEFAULT_VIEWER_HEIGHT"] = $ab2d871b1e9a6c2b$export$7ce912260e18e60d;
module.exports["ViewPdfMacroRenderer"] = $ab2d871b1e9a6c2b$export$ed196922a2e8619;

});

parcelRegister("kCqKs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $204vt = parcelRequire("204vt");


var $3Yohw = parcelRequire("3Yohw");

const $ccf786f89fdd66e5$var$defaultMediaClientConfig = {
    useSha256ForUploads: true
};
const $ccf786f89fdd66e5$export$8b3e87ea56c3a345 = ({ contentId: contentId, onMediaSessionError: onMediaSessionError, config: config, readOnly: readOnly })=>{
    const authProvider = (0, $3Yohw.useAuthProvider)({
        contentId: contentId,
        onMediaSessionError: onMediaSessionError,
        readOnly: readOnly
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!authProvider) return null;
        const mediaClientConfig = {
            authProvider: authProvider,
            ...$ccf786f89fdd66e5$var$defaultMediaClientConfig,
            ...config
        };
        return new (0, $204vt.MediaClient)(mediaClientConfig);
    }, [
        authProvider,
        config
    ]);
};
module.exports["useMediaClient"] = $ccf786f89fdd66e5$export$8b3e87ea56c3a345;

});

parcelRegister("3Yohw", function(module, exports) {

var $h5VWD = parcelRequire("h5VWD");


var $cozmU = parcelRequire("cozmU");


var $hP2NR = parcelRequire("hP2NR");

var $6Mfv2 = parcelRequire("6Mfv2");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $c0rhi = parcelRequire("c0rhi");


var $kUcBh = parcelRequire("kUcBh");


var $aQVc0 = parcelRequire("aQVc0");

const $08cf8a02c21b4b5f$var$isMediaSessionQueryDataValid = (data)=>Boolean(data?.contentMediaSession);
const $08cf8a02c21b4b5f$var$isReadOnlyMediaSessionQueryDataValid = (data)=>Boolean(data?.contentMediaSession?.accessTokens?.readOnlyToken?.value && data?.contentMediaSession?.configuration && !!data.contentMediaSession.configuration.clientId && !!data.contentMediaSession.configuration.fileStoreUrl);
const $08cf8a02c21b4b5f$var$createMediaSessionConfig = (0, $dOBRD.default)((data)=>({
        clientId: data.contentMediaSession.configuration.clientId,
        baseUrl: data.contentMediaSession.configuration.fileStoreUrl,
        token: data.contentMediaSession.token.value
    }));
const $08cf8a02c21b4b5f$export$3c8c0548d7719730 = ({ contentId: contentId, onMediaSessionError: onMediaSessionError, readOnly: readOnly })=>{
    const readMediaSessionFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $h5VWD.default),
        __callerPackage__: "media-client"
    });
    const getMediaSessionFromCache = (0, $cozmU.useCallback)(()=>{
        try {
            if (!contentId) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' contentId is not provided.");
            let cachedData;
            cachedData = readMediaSessionFragment({
                id: `$ROOT_QUERY.contentMediaSession(${JSON.stringify({
                    contentId: contentId
                })})`
            });
            // wrapper to fit expectations around original query code data shape
            cachedData = {
                contentMediaSession: cachedData
            };
            if (!$08cf8a02c21b4b5f$var$isMediaSessionQueryDataValid(cachedData)) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' invalid or missing data received from cache.");
            return cachedData;
        } catch  {
            // expected behavior
            // "readQuery" throws if there is no data in the store
            return;
        }
    }, [
        contentId,
        readMediaSessionFragment
    ]);
    const getMediaSessionFromServer = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!contentId) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' contentId is not provided.");
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $kUcBh.ContentMediaSessionQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "media-client"
            });
            if (!$08cf8a02c21b4b5f$var$isMediaSessionQueryDataValid(response.data)) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' invalid or missing data received from server.");
            if (response?.error) throw response.error;
            return response.data;
        } catch (err) {
            if (onMediaSessionError) onMediaSessionError(err);
            throw err;
        }
    }, [
        contentId,
        onMediaSessionError
    ]);
    const getReadOnlyMediaSessionFromServer = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!contentId) throw new Error("[useAuthProvider] For 'ContentReadOnlyMediaSessionQuery' contentId is not provided.");
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $aQVc0.ContentReadOnlyMediaSessionQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "media-client"
            });
            if (response?.error) throw response.error;
            if (!$08cf8a02c21b4b5f$var$isReadOnlyMediaSessionQueryDataValid(response.data)) throw new Error("[useAuthProvider] For 'ContentReadOnlyMediaSessionQuery' invalid or missing data received from server.");
            const session = response.data.contentMediaSession;
            return {
                clientId: session.configuration.clientId,
                baseUrl: session.configuration.fileStoreUrl,
                token: session.accessTokens.readOnlyToken.value
            };
        } catch (err) {
            if (onMediaSessionError) onMediaSessionError(err);
            throw err;
        }
    }, [
        contentId,
        onMediaSessionError
    ]);
    // Builds the media session config, including the token, from cache or server
    // It doesn't retry.
    const authProvider = (0, $cozmU.useCallback)(async ()=>{
        if (readOnly) return getReadOnlyMediaSessionFromServer();
        // countentId should be defined, otherwise this function shouldn't be called
        const cachedMediaSession = getMediaSessionFromCache();
        if (cachedMediaSession) {
            const expirationDateTime = new Date(cachedMediaSession.contentMediaSession.token.expiryDateTime);
            // It's expected to expire in 10mins. We'll renew it after 8mins.
            if (!(0, $6Mfv2.default)(new Date(), (0, $hP2NR.default)(expirationDateTime, -2))) return $08cf8a02c21b4b5f$var$createMediaSessionConfig(cachedMediaSession);
        }
        const freshMediaSession = await getMediaSessionFromServer();
        return $08cf8a02c21b4b5f$var$createMediaSessionConfig(freshMediaSession);
    }, [
        readOnly,
        getReadOnlyMediaSessionFromServer,
        getMediaSessionFromCache,
        getMediaSessionFromServer
    ]);
    if (!contentId) return null;
    return authProvider;
};
module.exports["useAuthProvider"] = $08cf8a02c21b4b5f$export$3c8c0548d7719730;

});

parcelRegister("h5VWD", function(module, exports) {
/**
 * @generated SignedSource<<136f6eb3c6ce4cf310c9c698de8d283b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3957ad7e9b1e26f3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useAuthProvider_mediaSession",
    "selections": [
        {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "token",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "kind": "ScalarField",
                    "name": "duration"
                },
                {
                    "kind": "ScalarField",
                    "name": "expiryDateTime"
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ],
    "type": "ContentMediaSession"
};
$3957ad7e9b1e26f3$var$node.hash = "b6236d605ad5cddede0d44adc63193ec";
var $3957ad7e9b1e26f3$export$2e2bcd8739ae039 = $3957ad7e9b1e26f3$var$node;
module.exports["default"] = $3957ad7e9b1e26f3$export$2e2bcd8739ae039;

});

parcelRegister("hP2NR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf995fbf1bdbe48c$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $bUJkW = parcelRequire("bUJkW");


var $3yGK6 = parcelRequire("3yGK6");

var $cf995fbf1bdbe48c$var$MILLISECONDS_IN_MINUTE = 60000;
function $cf995fbf1bdbe48c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $bUJkW.default)(dirtyDate, amount * $cf995fbf1bdbe48c$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("kUcBh", function(module, exports) {

var $6ysok = parcelRequire("6ysok");

const $813a893306ac94c7$export$308add891a1b58f7 = (0, $6ysok.default);
module.exports["ContentMediaSessionQuery"] = $813a893306ac94c7$export$308add891a1b58f7;

});

parcelRegister("6ysok", function(module, exports) {
/**
 * @generated SignedSource<<08a4344353678a0bb207b26902cca8f0>>
 * @relayHash 82f12ac8b34ad91537ec9fdf459226f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896
const $3ac88c8ffed86645$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiryDateTime"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "82f12ac8b34ad91537ec9fdf459226f1",
            "id": "f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896",
            "metadata": {},
            "name": "ContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ContentMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value,duration,expiryDateTime},configuration{clientId,fileStoreUrl}}}"
        }
    };
}();
$3ac88c8ffed86645$var$node.hash = "f17b5112a287e607ae81ac1df8d1533e";
var $3ac88c8ffed86645$export$2e2bcd8739ae039 = $3ac88c8ffed86645$var$node;
module.exports["default"] = $3ac88c8ffed86645$export$2e2bcd8739ae039;

});

parcelRegister("aQVc0", function(module, exports) {

var $2fOul = parcelRequire("2fOul");

const $a5c308ec66cfd677$export$e4d69deb7dc731e2 = (0, $2fOul.default);
module.exports["ContentReadOnlyMediaSessionQuery"] = $a5c308ec66cfd677$export$e4d69deb7dc731e2;

});

parcelRegister("2fOul", function(module, exports) {
/**
 * @generated SignedSource<<b208ac6cd76cb0a2e5921252f1541930>>
 * @relayHash 1991400b2462d0b72d81f1298a73c504
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44ec4e6ec111c9ff866a52aa9f2ebe84dc631f720e8ba2b72b24da9f321b53a5
const $a64aa8f901090a8a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentReadOnlyMediaSessionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentReadOnlyMediaSessionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1991400b2462d0b72d81f1298a73c504",
            "id": "44ec4e6ec111c9ff866a52aa9f2ebe84dc631f720e8ba2b72b24da9f321b53a5",
            "metadata": {},
            "name": "ContentReadOnlyMediaSessionQuery",
            "operationKind": "query",
            "text": "query ContentReadOnlyMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}},configuration{clientId,fileStoreUrl}}}"
        }
    };
}();
$a64aa8f901090a8a$var$node.hash = "a2478aa448d8ba882de605868f454f5f";
var $a64aa8f901090a8a$export$2e2bcd8739ae039 = $a64aa8f901090a8a$var$node;
module.exports["default"] = $a64aa8f901090a8a$export$2e2bcd8739ae039;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});


//# sourceMappingURL=ViewPdfMacroRenderer.d8bbed09.js.map
